import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-private-folder-badge',
  templateUrl: './private-folder-badge.component.html',
  styleUrls: ['./private-folder-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateFolderBadgeComponent {
  readonly publicFolder = input<boolean | undefined>();
}
